<template>
  <div v-if="hint" :class="['riddle__hint', { '--active': isOpen }]">
    <Transition name="hint-transition">
      <p class="riddle__hint-text" v-if="isOpen">
        <em>{{ `${$beet.options.hunt.labels.riddle.hint} : ` }}</em>
        <span>{{ hint }}</span>
      </p>
    </Transition>
    <button class="riddle__hint-button" type="button" @click.stop="isOpen = !isOpen">
      <Icon id="hint" />
    </button>
  </div>
</template>

<script>
import { Icon } from '@/components/global/index.js'

export default {
  name: 'FormHint',
  components: { Icon },
  props: {
    hint: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isOpen: false,
    }
  },
}
</script>
